<template>
  <v-card rounded>
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">Дата</th>
          <th class="text-left">Событие</th>
        </tr>
        </thead>
        <template v-if="load">
          <tbody>
          <tr>
            <td colspan="2">
              <v-progress-circular
                  indeterminate
                  color="primary"
                  size="15"
                  width="2"
                  class="mr-3"
              ></v-progress-circular>
              Загрузка
            </td>
          </tr>
          </tbody>
        </template>
        <template v-else>
          <tbody v-if="list.length">
          <tr v-for="(log, index) in list" :key="'ticket_log_'+index">
            <td v-text="getDate(log.created)"></td>
            <td v-text="!log.comment ? log.event : log.event + ' ' + getDate(log.comment)" />
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="2">События не найдены</td>
          </tr>
          </tbody>
        </template>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  name: 'History',
  props: ['list', 'load'],
  data: () => ({

  }),
  methods: {
    getDate(unix) {
      let date = new Date(unix * 1000);
      let hours = date.getHours();
      let minutes = "0" + date.getMinutes();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      let formattedTime = hours + ':' + minutes.substr(-2);
      let formattedDate = day + '-' + month + '-' + year;
      return formattedDate + ' ' + formattedTime;
    },
  }
}
</script>